import { useTheme } from '@mui/styles';

export const BAR_WIDTH = 4;
export const BAR_GAP = 2;

/** Hook that manages shared styles between our different waveform implementations. */
export const useSharedWaveformStyles = () => {
  const theme = useTheme();

  return {
    barGap: BAR_GAP,
    barWidth: BAR_WIDTH,
    progressColor: theme.palette.primary.main,
    waveColor: theme.palette.grey[400],
  };
};
